import classNames from 'classnames';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React, { Component, Suspense } from 'react';
import { createPortal } from 'react-dom';

import Button from '../Atoms/Button';
import Icon from '../Atoms/Icon';
import Loading from '../Core/Loading';

const propTypes = exact({
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  closeModalText: PropTypes.string,
  viewDetailsCtaText: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  isFullBleed: PropTypes.bool,
  isPackageComparisonModal: PropTypes.bool,
});

const defaultProps = {
  closeModalText: '',
  viewDetailsCtaText: '',
  isOpen: undefined,
  onClose: undefined,
  isFullBleed: false,
  isPackageComparisonModal: false,
};

export const modalOpenClass = 'modal-open';

class FullscreenModal extends Component {
  constructor(props) {
    super(props);

    this.handleModalOpen = this.handleModalOpen.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);

    this.state = { isOpen: false };
  }

  handleModalOpen() {
    document.body.classList.add(modalOpenClass);
    this.setState({ isOpen: true });
  }

  handleModalClose() {
    if (this.props.onClose) {
      this.props.onClose();
    } else {
      document.body.classList.remove(modalOpenClass);
      this.setState({ isOpen: false });
    }
    document.body.classList.remove(modalOpenClass);
  }

  render() {
    const isControlled = this.props.isOpen !== undefined;
    const isOpen = isControlled ? this.props.isOpen : this.state.isOpen;

    return (
      <>
        {!isControlled && (
          <Button
            text={this.props.viewDetailsCtaText}
            modifier="outline"
            handleClick={this.handleModalOpen}
          />
        )}
        {createPortal(
          <>
            {isOpen && <div className="FullscreenModal_overlay" />}
            <div
              className={classNames('FullscreenModal', {
                active: isOpen,
                isFullBleed: this.props.isFullBleed,
                isPackageComparisonModal: this.props.isPackageComparisonModal,
              })}
            >
              <div className="FullscreenModal_container">
                <div className="FullscreenModal_content">
                  <button
                    className="FullscreenModal_close"
                    type="button"
                    onClick={this.handleModalClose}
                  >
                    {this.props.closeModalText}{' '}
                    <Icon id="cross" blockName="FullscreenModal_closeIcon" />
                  </button>
                  {isOpen && <Suspense fallback={<Loading />}>{this.props.children}</Suspense>}
                </div>
              </div>
            </div>
          </>,
          document.body
        )}
      </>
    );
  }
}

FullscreenModal.propTypes = propTypes;
FullscreenModal.defaultProps = defaultProps;

export default FullscreenModal;
